"use strict";

import React, { Component } from 'react';

import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';

import p1 from '../img/img-patrocinio.jpg';
import p2 from '../img/img-apoio.jpg';
import p3 from '../img/img-realizacao.jpg';

class Footer extends Component {


    render() {
        console.log("render: footer");
        return (
            <footer className=" footer">
                <div className="limite">
                    <div>


                    </div>
                    <div className='rodape-patrocinio'>

                        <div className="rodape-patrocinio-item" >
                            <img src={p1}  />
                        </div>
                        <div className="rodape-patrocinio-item" >
                            <img src={p2}  />
                        </div>
                        <div className="rodape-patrocinio-item" >
                            <img src={p3}  />
                        </div>


                    </div>

                </div>
            </footer>
        );
    }
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js